<script setup lang="ts">
const route = useRoute()
const localeRoute = useLocaleRoute()

const props = defineProps<{
  routeObject: Object,
}>()
</script>

<template>
  <nuxt-link
    :to="localeRoute(routeObject)"
    :data-current="localeRoute(routeObject)?.path === route.path ? '' : null"
    class="focus:outline-none focus-visible:outline-none"
  >
    <slot /> 
  </nuxt-link>
</template>
